import { Card, CardContent } from "@mui/material";
import { TrainingPlans } from "./TrainingPlans";
import "./css/TrainingPlanCard.css";
import moment from "moment";
import GreenSwitch from "../ConfigPayroll/GreenSwitch";
import CheckPermission from "../../helpers/Administradores/Permissions";
import MenuTrainingPlan from "./MenuTrainingPlan";
import { useMutation } from "@apollo/client";
import {
  GET_ALL_TRAININGPLANS,
  UPDATE_TRAININGPLAN_STATUS,
} from "../../Querys/querys";
const TrainingPlanCard = ({
  trainingPlan,
}: {
  trainingPlan: TrainingPlans;
}) => {
  const {
    id,
    nameTrainingPlan,
    startTrainingPlan,
    endTrainingPlan,
    active,
    status,
    dateAdd,
    idCurso,
    descriptionTrainingPlan,
    totalCursos,
    expectedProgress,
    colaboradores,
    isEditable,
  } = trainingPlan;

  const dateInitFormat = moment(startTrainingPlan).utc().format("DD/MM/YYYY");
  const dateEndFormat = moment(endTrainingPlan).utc().format("DD/MM/YYYY");
  const permissionActivate = CheckPermission(
    "FormacionDesarrollo.TrainingPlans.Activar"
  );
  const permissionEdit = CheckPermission(
    "FormacionDesarrollo.TrainingPlans.Editar"
  );
  const permissionDelete = CheckPermission(
    "FormacionDesarrollo.TrainingPlans.Eliminar"
  );

  const [updateActive] = useMutation(UPDATE_TRAININGPLAN_STATUS, {
    refetchQueries: [{ query: GET_ALL_TRAININGPLANS }],
  });
  const updateTrainingPlanActive = async (id: any) => {
    try {
      await updateActive({
        variables: {
          updateTrainingplanStatusId: id,
        },
      });
    } catch (e) {}
  };
  return (
    <>
      <Card className="cardTrainingPlan">
        <CardContent className="contentTrainingPlan">
          <div className="headCampaign">
            <div className="headCampaignTitle">
              <span className="titleTrainingPlan">{nameTrainingPlan}</span>
            </div>
            <div className="headCampaignBtns">
              {permissionActivate ? (
                <div className="switchCourse">
                  <span className="actCourse">{active}</span>
                  <GreenSwitch
                    updatePayrollStatus={updateTrainingPlanActive}
                    id={id}
                    status={active}
                  />
                </div>
              ) : (
                <div className="switchCourse"></div>
              )}
              {(permissionEdit || permissionDelete) && (
                <div className="crudCourse">
                  <MenuTrainingPlan
                    id={id}
                    active={active}
                    isEditable={isEditable}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="contentTraining">
            <div className="descriptionTraining">
              <span className="descriptionText">{descriptionTrainingPlan}</span>
            </div>
          </div>
          <div className="">
            <span className="periodoCampaign">{`Periodo: ${dateInitFormat} - ${dateEndFormat}`}</span>
          </div>
          <div className="definirCard">
            <div className="evaluarContain">
              <div>
                <span className="evaluarTxt">{totalCursos}</span>
              </div>
              <div>
                <span className="msjEvaluar">Cursos</span>{" "}
              </div>
            </div>
            <div className="ev-line"></div>
            <div className="evaluarContain">
              <div>
                <span className="evaluarTxt">{colaboradores}</span>
              </div>
              <div>
                <span className="msjEvaluar">Colaboradores</span>
              </div>
            </div>
            <div className="ev-line"></div>
            <div className="evaluarContain">
              <div>
                <span className="evaluarTxt">{expectedProgress} %</span>
              </div>
              <div>
                <span className="msjEvaluar">Progreso</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default TrainingPlanCard;
